import React, { useContext, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import sanitize from 'sanitize-html';
import cx from 'classnames';
import { getImageUrl } from '@culture/common-helpers/cultureUtils';
import { getThumbnailDescription } from '@culture/common-helpers/media';

import { ImageFormatContext } from 'contexts/ImageFormatContext';
import Preloader from 'components/Preloader';

import CommonPropTypes from 'utils/propTypes/common';

import styles from '../styles.module.scss';

const Image = ({ file, alone }) => {
	const [loaded, setLoaded] = useState(false);
	const imageFormat = useContext(ImageFormatContext);

	const onLoad = useCallback(() => {
		setLoaded(true);
	}, []);

	const description = getThumbnailDescription(file);
	const itemCx = cx(styles.lightboxItem, {
		[styles.withDescription]: !!description,
		[styles.alone]: alone
	});

	return (
		<div className={itemCx}>
			<img
				src={getImageUrl(file, { format: imageFormat })}
				className={styles.image}
				alt={file.meta?.title}
				onLoad={onLoad}
			/>
			{loaded ? (
				description && (
					<div className={styles.description}>
						{parse(sanitize(description))}
					</div>
				)
			) : (
				<Preloader className={styles.preloader} />
			)}
		</div>
	);
};

Image.propTypes = {
	file: CommonPropTypes.file.isRequired,
	alone: PropTypes.bool
};

Image.defaultProps = {
	alone: false
};

export default Image;
